"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");
/**
 * Factor
 * @description Defines the value of the padding.
 * DEFAULT means one building unit,
 * DOUBLE two units,
 * NONE no padding of course.
 */


var Factor;

(function (Factor) {
  Factor["DEFAULT"] = "";
  Factor["DOUBLE"] = "-x2";
  Factor["NONE"] = "-no";
})(Factor = exports.Factor || (exports.Factor = {}));
/**
 * Range
 * @description The range that should be targeted.
 * Range.EXACT means ONLY the passed VP,
 * Range.MIN means the passed VP and higher,
 * Range.MAX means all VPs til the passed VP,
 */


var Range;

(function (Range) {
  Range["MIN"] = "min";
  Range["MAX"] = "max";
  Range["EXACT"] = "exact";
})(Range = exports.Range || (exports.Range = {}));
/**
 * Viewport
 * @description List of available Viewports.
 */


var Viewport;

(function (Viewport) {
  Viewport["ALL"] = "";
  Viewport["XS"] = "-xs";
  Viewport["SM"] = "-sm";
  Viewport["MD"] = "-md";
  Viewport["LG"] = "-lg";
  Viewport["XL"] = "-xl";
})(Viewport = exports.Viewport || (exports.Viewport = {}));
/**
 * Position
 * @description List of positions where the padding of the div could be set.
 */


var Position;

(function (Position) {
  Position["TOP"] = "-top";
  Position["BOTTOM"] = "-bottom";
  Position["LEFT"] = "-left";
  Position["RIGHT"] = "-right";
  Position["ALL"] = "";
  Position["LEFTRIGHT"] = "-left-right";
  Position["TOPBOTTOM"] = "-top-bottom";
})(Position = exports.Position || (exports.Position = {}));
/**
 * Spacer
 * @description Adds a surrounding div with optional padding.
 */


var Spacer =
/** @class */
function (_super) {
  __extends(Spacer, _super);

  function Spacer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * getValue
   * @description Static function which helps to create the desired SpacerValue
   * @function
   * @static
   * @param {Position} position - Position of the padding
   * @param {Viewport} viewport - Viewport to be targeted.
   * @param {Range} range - Range that should be targeted.
   * @param {Factor} factor - Size of the padding
   */


  Spacer.getValue = function (position, viewport, range, factor) {
    if (viewport === void 0) {
      viewport = Viewport.ALL;
    }

    if (range === void 0) {
      range = Range.EXACT;
    }

    if (factor === void 0) {
      factor = Factor.DEFAULT;
    }

    return Spacer.createValue(position, viewport, range, factor);
  };
  /**
   * getZeroValue
   * @description Static shorthand function to get a no-padding SpacerValue
   * @function
   * @static
   * @param {Position} position - Position of the padding
   * @param {Viewport} viewport - Viewport to be targeted.
   * @param {Range} range - Range that should be targeted.
   */


  Spacer.getZeroValue = function (position, viewport, range) {
    if (viewport === void 0) {
      viewport = Viewport.ALL;
    }

    if (range === void 0) {
      range = Range.EXACT;
    }

    return Spacer.createValue(position, viewport, range, Factor.NONE);
  };
  /**
   * getDoubleValue
   * @description Static shorthand function to get a double-padding SpacerValue
   * @function
   * @static
   * @param {Position} position - Position of the padding
   * @param {Viewport} viewport - Viewport to be targeted.
   * @param {Range} range - Range that should be targeted.
   */


  Spacer.getDoubleValue = function (position, viewport, range) {
    if (viewport === void 0) {
      viewport = Viewport.ALL;
    }

    if (range === void 0) {
      range = Range.EXACT;
    }

    return Spacer.createValue(position, viewport, range, Factor.DOUBLE);
  };

  Spacer.createValue = function (position, viewport, range, factor) {
    if (range === void 0) {
      range = Range.EXACT;
    }

    if (factor === void 0) {
      factor = Factor.DEFAULT;
    }

    var pos;

    switch (position) {
      case Position.ALL:
        pos = [Position.TOP, Position.BOTTOM, Position.LEFT, Position.RIGHT];
        break;

      case Position.TOPBOTTOM:
        pos = [Position.TOP, Position.BOTTOM];
        break;

      case Position.LEFTRIGHT:
        pos = [Position.LEFT, Position.RIGHT];
        break;

      default:
        pos = [position];
    }

    return {
      position: pos,
      viewport: viewport,
      factor: factor,
      range: range
    };
  };

  Spacer.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        paddings = _a.paddings,
        className = _a.className,
        debug = _a.debug,
        previewDark = _a.previewDark,
        children = _a.children;
    var uuid = id || uniqid_1["default"]("lsg--spacer-");
    /**
     * Merge Values to class name
     */

    var getPaddingClassName = function getPaddingClassName(position, viewport, factor) {
      return CSSPrefix_1.lsgPre + "spacer__padding" + position + viewport + factor;
    };
    /**
     * Iterate through SpacerValues and create class names
     */


    var getPaddingClasses = function getPaddingClasses(spacerValues) {
      // Create array list of viewports
      var viewportList = Object.values(Spacer.Viewport);
      return spacerValues.map(function (spacerValue // iterate over all spacerValues, spacerValue will be the current one
      ) {
        return spacerValue.position.map(function (position) {
          // iterate over all positions within the current spacerValue, position will be the current one
          var range = spacerValue.viewport !== Viewport.ALL ? spacerValue.range : Range.EXACT;
          return range === Range.MIN && viewportList.map( // get all values of Viewport enum as array and iterate over them
          function (viewport, i) {
            return viewport !== Spacer.Viewport.ALL && viewportList.indexOf(spacerValue.viewport) <= i // condition to return a className - only if current viewport is not ALL and if the passed viewports' index is higher than the current map index
            ? getPaddingClassName(position, viewportList[i], spacerValue.factor) // return a className to the map function (will be "pushed to the array")
            : "";
          }).join(" ") || // join all items within the mapped array to generate a string like 'className1 className2 ...'
          range === Range.MAX && // this is all exactly the same as above - you can potentially reduce redundant code here
          viewportList.map(function (viewport, i) {
            return viewport !== Spacer.Viewport.ALL && viewportList.indexOf(spacerValue.viewport) >= i // only this time we're checking if the passed viewports' index is lower than the current map index
            ? getPaddingClassName(position, viewportList[i], spacerValue.factor) : "";
          }).join(" ") || // always join the mapped array to generate a string... In the (hopefully soon) future there will be Array.flatten, so you can just flatten every Array created by a map in here, and only join() once.
          range === Range.EXACT && // and just return one className if range is EXACT
          getPaddingClassName(position, spacerValue.viewport, spacerValue.factor);
        }).join(" ");
      } // join positions mapped array
      ).join(" "); // join spacerValues mapped array
    };

    var classNames = utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "spacer", className, CSSPrefix_1.prefixEnumClassNames(getPaddingClasses(paddings)), debug && CSSPrefix_1.lsgPre + "spacer__debug", previewDark && CSSPrefix_1.lsgPre + "spacer__preview-dark"]);
    var spacerProps = {
      className: classNames,
      id: uuid
    };
    return React.createElement("div", __assign({}, spacerProps), children);
  };

  Spacer.Position = Position;
  Spacer.Viewport = Viewport;
  Spacer.Factor = Factor;
  Spacer.Range = Range;
  Spacer.defaultProps = {
    debug: false,
    previewDark: false,
    paddings: [Spacer.getValue(Spacer.Position.LEFTRIGHT)]
  };
  /**
   * Some pre-defined defaults
   * @type {SpacerValue}
   */

  Spacer.DEFAULT_PADDING_ALL_SIDES = [Spacer.getValue(Position.ALL)];
  Spacer.DEFAULT_PADDING_TOP_BOTTOM = [Spacer.getValue(Position.TOPBOTTOM)];
  Spacer.DEFAULT_SIDE_PADDING_EXCEPT_XS = [Spacer.getValue(Position.LEFTRIGHT, Viewport.SM, Range.MIN, Factor.DEFAULT)];
  Spacer.DEFAULT_SIDE_PADDING_MD_AND_HIGHER = [Spacer.getValue(Position.LEFTRIGHT, Viewport.MD, Range.MIN, Factor.DEFAULT)]; // Spacer.AllSides

  Spacer.AllSides = function (props) {
    return React.createElement(Spacer, __assign({
      paddings: [Spacer.getValue(Position.ALL)]
    }, props));
  }; // Spacer.TopBottom


  Spacer.TopBottom = function (props) {
    return React.createElement(Spacer, __assign({
      paddings: [Spacer.getValue(Position.TOPBOTTOM)]
    }, props));
  }; // Spacer.PageContent


  Spacer.PageContent = function (props) {
    return React.createElement(Spacer, __assign({
      paddings: [Spacer.getValue(Position.LEFTRIGHT, Viewport.LG, Range.MAX, Factor.DEFAULT)]
    }, props));
  };

  return Spacer;
}(React.Component);

exports.Spacer = Spacer;